"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsPieChart = exports.DmsLineChart = exports.DmsCustomChart = exports.DmsBarChart = void 0;
var _react = _interopRequireWildcard(require("react"));
var _chart = require("chart.js");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/* 
This is an example on how to create the chart on your application
    const Chart = () => {
        return (
            <div>
            <h1>{intl.get("MyChart").d("My Chart App")}</h1>
            <DmsLineChart datasets={chartData.datasets} options={chartOptions} labels={chartData.labels} />
          </div>
        );
    };
    
    const chartOptions = {
        scales: {
          x: {
            beginAtZero: true,
          },
          y: {
            beginAtZero: true,
          },
        },
      };
      
    const chartData = {
        labels: ['Label 1', 'Label 2', 'Label 3', 'Label 4', 'Label 5', 'Label 6'],
        datasets: [
          {
            label: 'Dataset 1',
            data: [10, 20, 30, 40, 50, 60],
            backgroundColor: 'rgba(62, 149, 205, 0.5)',
            borderColor: 'rgb(62, 149, 205)',
            borderWidth: 1,
          },
        ],
      };

    const customRoutes = [];
*/
_chart.Chart.register(_chart.CategoryScale, _chart.LinearScale, _chart.BarElement, _chart.PointElement, _chart.LineElement, _chart.LineController, _chart.BarController, _chart.PieController, _chart.RadarController, _chart.Title, _chart.Tooltip, _chart.Legend, _chart.ArcElement, _chart.RadialLinearScale);
const DmsChart = _ref => {
  let {
    datasets,
    options,
    type,
    labels,
    plugins
  } = _ref;
  const chartRef = (0, _react.useRef)(null);
  const chartInstanceRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(() => {
    // if a chart already exists, destroy if before creating a new one
    if (chartInstanceRef.current) {
      chartInstanceRef.current.destroy();
    }
    if (datasets && chartRef.current) {
      const ctx = chartRef.current.getContext("2d");

      // create a new chart and assign the instance to the reference
      chartInstanceRef.current = new _chart.Chart(ctx, {
        type: type,
        data: {
          labels: labels,
          datasets: datasets
        },
        options: options,
        plugins: plugins || []
      });
    }

    // cleaning the chart when disassembling the component
    return () => {
      if (chartInstanceRef.current) {
        chartInstanceRef.current.destroy();
      }
    };
  }, [datasets, options, type, labels, plugins]);
  return /*#__PURE__*/_react.default.createElement("canvas", {
    ref: chartRef
  });
};
DmsChart.displayName = "DmsChart";
const DmsBarChart = _ref2 => {
  let {
    datasets,
    options,
    labels,
    plugins
  } = _ref2;
  return /*#__PURE__*/_react.default.createElement(DmsChart, {
    type: "bar",
    datasets: datasets,
    options: options,
    labels: labels,
    plugins: plugins
  });
};
exports.DmsBarChart = DmsBarChart;
const DmsLineChart = _ref3 => {
  let {
    datasets,
    options,
    labels,
    plugins
  } = _ref3;
  return /*#__PURE__*/_react.default.createElement(DmsChart, {
    type: "line",
    datasets: datasets,
    options: options,
    labels: labels,
    plugins: plugins
  });
};
exports.DmsLineChart = DmsLineChart;
const DmsPieChart = _ref4 => {
  let {
    datasets,
    options,
    labels
  } = _ref4;
  return /*#__PURE__*/_react.default.createElement(DmsChart, {
    type: "pie",
    datasets: datasets,
    options: options,
    labels: labels
  });
};
exports.DmsPieChart = DmsPieChart;
const DmsCustomChart = _ref5 => {
  let {
    datasets,
    options,
    labels,
    type
  } = _ref5;
  return /*#__PURE__*/_react.default.createElement(DmsChart, {
    type: type,
    datasets: datasets,
    options: options,
    labels: labels
  });
};
exports.DmsCustomChart = DmsCustomChart;